import { useState } from "react";
import { KeyRound, Save } from "lucide-react";
import { toast } from "sonner";
import { useAuth, adminApi, formatApiError } from "../context/AuthContext";
import { Card, inputClass, labelClass, btnPrimary } from "./fields";

export default function AdminAccount() {
  const { user } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [repeat, setRepeat] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next.length < 8) return setError("Het nieuwe wachtwoord moet minimaal 8 tekens lang zijn.");
    if (next !== repeat) return setError("De nieuwe wachtwoorden komen niet overeen.");
    setBusy(true);
    try {
      await adminApi.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Wachtwoord gewijzigd", { description: "Gebruik voortaan je nieuwe wachtwoord om in te loggen." });
      setCurrent("");
      setNext("");
      setRepeat("");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-account-page" className="space-y-6">
      <div>
        <h1 className="font-display text-3xl font-bold uppercase tracking-wide text-[#111111]">Account</h1>
        <p className="mt-1 text-sm text-[#555555]">Ingelogd als {user?.email}</p>
      </div>
      <form onSubmit={submit} className="max-w-lg" data-testid="change-password-form">
        <Card title="Wachtwoord wijzigen">
          <div>
            <label htmlFor="pw-current" className={labelClass}>Huidig wachtwoord</label>
            <input id="pw-current" data-testid="password-current" type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} className={inputClass} autoComplete="current-password" />
          </div>
          <div>
            <label htmlFor="pw-new" className={labelClass}>Nieuw wachtwoord (minimaal 8 tekens)</label>
            <input id="pw-new" data-testid="password-new" type="password" required minLength={8} value={next} onChange={(e) => setNext(e.target.value)} className={inputClass} autoComplete="new-password" />
          </div>
          <div>
            <label htmlFor="pw-repeat" className={labelClass}>Herhaal nieuw wachtwoord</label>
            <input id="pw-repeat" data-testid="password-repeat" type="password" required value={repeat} onChange={(e) => setRepeat(e.target.value)} className={inputClass} autoComplete="new-password" />
          </div>
          {error && <p data-testid="password-error" className="border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}
          <div className="flex justify-end border-t border-[#E2E0D9] pt-4">
            <button type="submit" data-testid="password-save" disabled={busy} className={btnPrimary}>
              <Save className="h-4 w-4" /> {busy ? "Opslaan..." : "Wachtwoord opslaan"}
            </button>
          </div>
        </Card>
      </form>
      <p className="flex max-w-lg items-start gap-2 text-xs leading-relaxed text-[#8E8D8A]">
        <KeyRound className="mt-0.5 h-3.5 w-3.5 shrink-0" />
        Wachtwoord vergeten? Zet dan een nieuw wachtwoord in ADMIN_PASSWORD bij de backend-instellingen (secrets) en publiceer opnieuw. Dat nieuwe wachtwoord geldt dan direct.
      </p>
    </div>
  );
}
